<template>
  <v-app>
    <Navigations :breadcrumbs="this.breadcrumb" />
    <v-main>
      <v-container>
        <v-row class="pb-2">
          <v-col cols="6"> </v-col>
          <v-col cols="6" class="ml-auto text-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="secondary" elevation="0" v-bind="attrs" v-on="on">
                  Profiel toevoegen
                </v-btn>
              </template>
              <v-list>
                <v-list-item to="/profiles/create">
                  Éen profiel toevoegen
                </v-list-item>
                <v-list-item @click="openMenu">
                  Profielen importeren
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>

        <v-list color="#f5f5f9" class="pt-2 rounded-lg">
          <v-list-item v-for="profile in profiles" :key="profile.title">
            <v-card
              elevation="0"
              class="pa-3 h-100 col-12 my-2"
              :to="profile.to"
            >
              <v-row>
                <v-col cols="2" sm="1" class="py-0 my-auto">
                  <v-list-item-avatar>
                    <v-img
                      :alt="`${profile.title} avatar`"
                      :src="profile.avatar"
                    ></v-img>
                  </v-list-item-avatar>
                </v-col>
                <v-col cols="10" sm="3" class="py-0 my-auto">
                  <v-list-item-content>
                    <strong v-text="profile.name"></strong>
                    <v-list-item-title
                      v-text="profile.functiontitle"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-col>
                <v-col cols="12" sm="3" class="py-0 my-auto">
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="profile.companyname"
                    ></v-list-item-title>
                    <small>{{ profile.company_adres }}</small>
                  </v-list-item-content>
                </v-col>
                <v-col cols="6" sm="1" class="text-right my-auto ml-auto">
                  <v-img
                    v-if="profile.card_type === 'Virtual'"
                    width="100"
                    src="../../assets/kyano-virtual-card.svg"
                  ></v-img>
                  <v-img
                    v-if="profile.card_type === 'Businesscard'"
                    width="100"
                    src="../../assets/kyano-business-card.svg"
                  ></v-img>
                </v-col>
                <v-col cols="6" sm="2" class="text-right my-auto ml-auto">
                  <v-btn :to="profile.to" text outlined color="primary">
                    Bewerken
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-list-item>
        </v-list>
      </v-container>
    </v-main>
    <Drawer :direction="'right'" :exist="true" ref="LeftDrawer">
      <v-container fluid class="pa-5 pa-md-15">
        <v-row>
          <v-col cols="6">
            <h2>Profielen importeren</h2>
          </v-col>
          <v-col cols="6">
            <v-btn
              color="danger"
              large
              icon
              style="float: right"
              @click="openMenu()"
              elevation="0"
            >
              <v-icon>fal fa-times</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-divider class="my-5"></v-divider>

        <v-img
          width="300"
          class="m-auto text-center mb-10"
          src="../../assets/illustrations/team-page.svg"
        ></v-img>

        <v-row>
          <v-col cols="12" class="text-center">
            <p>Beheer meerdere profielen door ze als bulk te importeren.</p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">           
             <div>
      <v-btn
        color="secondary" elevation="0"
        class="text-none"
        round
        depressed
        :loading="isSelecting"
        @click="onButtonClick"
      >

        {{ buttonText }}
      </v-btn>
      <input
        ref="uploader"
        class="d-none"
        type="file"
        accept="image/*"
        @change="onFileChanged"
      >
    </div>
          </v-col>
        </v-row>
      </v-container>
    </Drawer>
  </v-app>
</template>
<script>
import Navigations from "../../components/Navigations.vue";
import Drawer from "../../components/Drawer.vue";

export default {
  components: {
    Navigations,
    Drawer,
  },

  computed: {
    buttonText() {
      return this.selectedFile
        ? this.selectedFile.name
        : this.defaultButtonText;
    },
  },
  methods: {
    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.selectedFile = e.target.files[0];

      // do something
    },

    openMenu() {
      if (this.$refs.LeftDrawer.active) {
        this.$refs.LeftDrawer.close();
      } else {
        this.$refs.LeftDrawer.open();
      }
    },
    handleClick(v) {
      this.$router.push(v.to);
    },
    newprofile() {
      // HIER WORD GEPOST NAAR DE BACKEND
      // DAARNA DOOR ROUTEN
    },
  },

  data() {
    return {
      defaultButtonText: "Bestand selecteren",
      selectedFile: null,
      isSelecting: false,
      tab: null,
      itemss: ["Uitnodigen", "Aanmaken"],

      tabcreate: [
        {
          tab: "uitnodigen",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        },
        {
          tab: "uitnodigen",
          text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        },
      ],

      breadcrumb: [
        {
          text: "Profielen",
          disabled: true,
          href: "/profiles",
        },
      ],

      profiles: [
        {
          id: 1,
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          name: "Gianni Hesseling",
          functiontitle: "Developer",
          companyname: "Kyano",
          company_adres: "Moermansweg 2-22, 9723HM Groningen",
          card_type: "Virtual",
          to: `/profiles/2`,
        },
        {
          id: 2,
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          name: "Gianni Hesseling",
          functiontitle: "Developer",
          companyname: "Snelwebcenter",
          company_adres: "Moermansweg 2-22, 9723HM Groningen",
          card_type: "Businesscard",
          to: `/profiles/2`,
        },
        {
          id: 3,
          avatar: "https://cdn.vuetifyjs.com/images/lists/1.jpg",
          name: "Gianni Hesseling",
          functiontitle: "Developer",
          companyname: "Snelwebcenter",
          company_adres: "Moermansweg 2-22, 9723HM Groningen",
          card_type: "Businesscard",
          to: `/profiles/2`,
        },
      ],
    };
  },
};
</script>